import { render, staticRenderFns } from "./BaseSearchbar.vue?vue&type=template&id=1dbadf54"
import script from "./BaseSearchbar.vue?vue&type=script&lang=ts"
export * from "./BaseSearchbar.vue?vue&type=script&lang=ts"
import style0 from "./BaseSearchbar.vue?vue&type=style&index=0&id=1dbadf54&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports